import React from 'react';
import { AlertTriangleIcon, CheckIcon } from 'lucide-react';
import { Countdown } from './Countdown';
import { CTAButton } from './CTAButton';
export function OfferSection() {
  return <section id="comprar" className="bg-blush py-10 sm:py-24" data-id="element-198" data-mp="8nopf9wt4kto">
      <div className="mx-auto max-w-3xl px-5" data-id="element-199" data-mp="8lc2sjg3tmaa">
        <div className="rounded-3xl bg-white p-4 shadow-xl shadow-rose/10 ring-1 ring-rose/10 sm:p-10" data-id="element-200" data-mp="deex4tspgzrj">
          <div className="text-center" data-id="element-201" data-mp="idzzle733q90">
            <p className="inline-flex items-center gap-1.5 text-xs font-bold uppercase tracking-wide text-rose-deep sm:text-sm sm:tracking-widest" data-id="element-202" data-mp="ifb0n695ajwf">
              ⏰ Precio de lanzamiento — cierra en:
            </p>
            <Countdown className="mt-3 sm:mt-5" data-id="element-203" data-mp="rc3kq9e5ql0a" />
            <p className="mt-2 inline-flex items-center gap-1.5 text-xs font-semibold text-ink/70 sm:mt-4 sm:text-sm" data-id="element-204" data-mp="wby6jyj2skeh">
              <AlertTriangleIcon className="h-3.5 w-3.5 text-rose sm:h-4 sm:w-4" data-id="element-205" data-mp="2t6ugpajc9foh" /> Después sube. No vuelve.
            </p>
          </div>

          <div className="mt-5 rounded-2xl border border-rose/15 bg-blush/60 p-4 sm:mt-8 sm:p-5" data-id="element-206" data-mp="12niedon92hv2">
            <div className="flex items-center justify-between gap-2 text-xs font-semibold text-ink sm:text-sm" data-id="element-207" data-mp="xws4by3vpqu1">
              <span className="inline-flex items-center gap-1.5" data-id="element-208" data-mp="sx76jr0g3oiw">
                🔴 Cupos al precio de lanzamiento
              </span>
              <span className="shrink-0 text-rose-deep" data-id="element-209" data-mp="oxonl0s6pnip">Quedan pocos</span>
            </div>
            <div className="mt-2 h-2.5 w-full overflow-hidden rounded-full bg-white sm:mt-3 sm:h-3" data-id="element-210" data-mp="1ll338vq0lgfo">
              <div className="h-full w-[68%] rounded-full bg-rose" data-id="element-211" data-mp="1gokz9y2idm4e" />
            </div>
            <p className="mt-1.5 text-[0.7rem] text-ink/60 sm:mt-2 sm:text-xs" data-id="element-212" data-mp="1ckn23swquldz">
              68% de los cupos al precio de lanzamiento ya tomados
            </p>
          </div>

          <div className="mt-5 rounded-2xl border-2 border-rose bg-white p-4 text-center sm:mt-8 sm:p-6" data-id="element-213" data-mp="172gbbq0879r">
            <h3 className="font-display text-lg font-black text-ink sm:text-xl" data-id="element-214" data-mp="3sckmp59by8zb">
              📘 MegaPack Estética Digital Pro
            </h3>
            <p className="mt-0.5 text-xs text-ink/70 sm:mt-1 sm:text-sm" data-id="element-215" data-mp="3tustsvi58dzh">6 Tomos + 4 Bonos</p>
            <p className="mt-2 hidden text-xs text-ink/55 sm:mt-3 sm:block" data-id="element-216" data-mp="2mx0xhi7e8dz">
              Ideal para: Dueñas de estéticas que manejan solas su Instagram
            </p>
            <div className="mt-3 flex items-end justify-center gap-2 sm:mt-5 sm:gap-3" data-id="element-217" data-mp="3otvbmix4vjxz">
              <span className="text-base text-ink/40 line-through sm:text-lg" data-id="element-218" data-mp="3b389egs5zbx5">$49.990</span>
              <span className="font-display text-4xl font-black text-rose-deep sm:text-[40px]" data-id="element-219" data-mp="3fuqe9fxb5wne">$19.990</span>
              <span className="mb-1 text-xs font-semibold text-ink/60 sm:text-sm" data-id="element-220" data-mp="3163o0j657khe">ARS</span>
            </div>
            <div className="mt-4 flex justify-center px-1 sm:mt-6" data-id="element-221" data-mp="365gj1r763xv2">
              <CTAButton className="w-full max-w-[18rem] whitespace-nowrap px-3 text-xs sm:w-auto sm:max-w-none sm:px-8 sm:text-base" data-id="element-222" data-mp="2s4w2l1oq6e4q" />
            </div>
            <div className="mt-3 flex flex-wrap items-center justify-center gap-x-3 gap-y-1 text-[0.68rem] text-ink/55 sm:mt-4 sm:gap-x-4 sm:text-xs" data-id="element-223" data-mp="2x2xjbfyoi1d1">
              <span className="inline-flex items-center gap-1" data-id="element-224" data-mp="28jdmgyjw3tty">
                <CheckIcon className="h-3.5 w-3.5 text-rose" data-id="element-225" data-mp="28l6wmntpow6p" /> Garantía 7 días
              </span>
              <span className="inline-flex items-center gap-1" data-id="element-226" data-mp="2mgacixs6p79s">
                <CheckIcon className="h-3.5 w-3.5 text-rose" data-id="element-227" data-mp="2ig8npp7js8bx" /> Pago seguro
              </span>
              <span className="inline-flex items-center gap-1" data-id="element-228" data-mp="2wfi0sg0gimbo">💳 Mercado Pago</span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}